import { mapGetters } from 'vuex'

import { hasInternalRole, hasSettlementAccountRole } from '@/utils/adminRole'

/**
 * **「이 사람은 오더엔 내부 관리자인가」 한 곳** — 세션을 읽는 자리를 컴포넌트마다 다시 적지 않는다.
 *
 * 같은 computed 가 네 곳에 퍼질 참이었고(사업장 트리·매장 정보·알림톡·사업자정보) 읽는 방법조차 갈렸다
 * (`mapGetters` 와 `$store.getters` 직접). 사본이 갈리면 한 화면만 고쳐질 때 같은 폼의 어떤 칸은
 * `mng` 에게 보이고 어떤 칸은 안 보인다 — 실제로 그렇게 「소속 사업장은 보이는데 정산은행은 없는」
 * 폼이 만들어졌다.
 *
 * 판정 자체는 `utils/adminRole.isInternalRole`(순수, 서버 `CallerRole.INTERNAL_ROLES` 와 같은 어휘)이
 * 갖는다 — 이 믹스인은 그 술어에 **이 앱의 세션**을 먹이는 경계일 뿐이다.
 *
 * `authId` 도 함께 내보낸다. 같은 게터를 두 번 매핑하면(예: `storeFormMixin` 과 함께 쓰는 화면) 값이
 * 같으므로 문제가 없고, 이 믹스인만 쓰는 컴포넌트는 스토어를 직접 읽지 않아도 된다.
 */
export const adminRoleMixin = {
  computed: {
    ...mapGetters({
      authId: 'auth/authId',
      auths: 'auth/auths',
    }),
    /**
     * 오더엔 내부 관리자(`admin`·`mng`)인가 — 화면이 「관리자 전용 칸」을 그릴지 정하는 하나의 질문.
     *
     * **역할 목록 전체**를 본다(`auth/authId` 는 첫 역할 하나다). 서버 `CallerScope.isInternal` 이
     * 그러기 때문이고, 어긋나면 겸직 계정에서 서버가 열어 준 일을 화면이 그리지 않는다.
     */
    isInternalAdmin() {
      return hasInternalRole(this.auths)
    },
    /**
     * 정산 계좌(은행·계좌번호·예금주)를 고칠 수 있는가 — 내부 역할보다 **좁다**(`admin` 만).
     * 화면이 역할 문자열을 직접 비교하지 않도록 여기서 답한다(`utils/adminRole`).
     */
    canEditSettlementAccount() {
      return hasSettlementAccountRole(this.auths)
    },
  },
}

export default adminRoleMixin
